export enum SubPagesEnum {
  settings = "settings",
  progress = "progress",
  progressByContent = "progress-by-content",
  progressByStudent = "progress-by-student",
  manage = "manage",
  teacherOverall = "teacher-overall"
}

export type Tabs = { label: string; value: SubPagesEnum; icon: string }
